import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import PortalEditData from "./PortalModel/PortalEditData"

export default function PortalUpdateObservable(data: PortalEditData): Observable<string> {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderClinicFileMaintenance/UpdateClinicInformation", requestBody)
}
